<template>
    <div class="posts-wrapper">
        <div class="packages orders">
            <div class="box-white-wrapper">
                <div class="d-flex mb-4 flex-end dispatchAll">
                    En BoxLogistics
                    <vs-switch v-model="onlyBox" color="success" @change="filterTableOnlyBox()"/>
                </div>
                <vs-table :data="packages" pagination search max-items="50">
                        <template slot="header" v-if="userInfoData.role == Roles.Admin">
                            <vs-button color="primary" type="border" icon="library_add" style="margin-right: 15px"
                                @click="openModalFile">Cargar Datos</vs-button>
                        </template>
                        <template slot="thead">
                            <vs-th sort-key="AEROTRACK">Guía Aerea</vs-th>
                            <!-- <vs-th sort-key="WEIGHT_KG">WEIGHT_KG</vs-th>
                            <vs-th sort-key="DECLARED_VALUE">DECLARED_VALUE </vs-th> -->
                            <!-- <vs-th sort-key="ACCOUNT">ACCOUNT </vs-th> -->
                            <vs-th sort-key="CONSIGNEE">CONSIGNEE </vs-th>
                            <vs-th sort-key="COURIER_TRACKING"> COURIER TRACKING </vs-th>
                            <vs-th sort-key="AIR_WAYBILL"> AIR WAYBILL </vs-th>
                            <!-- <vs-th sort-key="CURRENT_STATUS"> CURRENT STATUS </vs-th> -->
                            <vs-th sort-key="CURRENT_STATUS_COMMENT"> CURRENT STATUS COMMENT </vs-th>
                            <vs-th sort-key="LAST_STATUS_DATETIME"> LAST STATUS DATETIME </vs-th>
                            <vs-th sort-key="id" style="min-width: 95px;"></vs-th>
                        </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td :data="data[indextr].AEROTRACK">{{data[indextr].AEROTRACK }}</vs-td>
                            <!-- <vs-td :data="data[indextr].WEIGHT_KG">{{data[indextr].WEIGHT_KG }}</vs-td>
                            <vs-td :data="data[indextr].DECLARED_VALUE">{{data[indextr].DECLARED_VALUE }}</vs-td> -->
                            <!-- <vs-td :data="data[indextr].ACCOUNT">{{data[indextr].ACCOUNT }}</vs-td> -->
                            <vs-td :data="data[indextr].CONSIGNEE">{{data[indextr].CONSIGNEE }}</vs-td>
                            <vs-td :data="data[indextr].COURIER_TRACKING">{{data[indextr].COURIER_TRACKING }}</vs-td>
                            <vs-td :data="data[indextr].AIR_WAYBILL">{{data[indextr].AIR_WAYBILL }}</vs-td>
                            <!-- <vs-td :data="data[indextr].CURRENT_STATUS">{{data[indextr].CURRENT_STATUS }}</vs-td> -->
                            <vs-td :data="data[indextr].CURRENT_STATUS_COMMENT">{{data[indextr].CURRENT_STATUS_COMMENT }}</vs-td>
                            <vs-td :data="data[indextr].LAST_STATUS_DATETIME">{{data[indextr].LAST_STATUS_DATETIME | moment('DD-MM-YYYY') }}</vs-td> 
                            <vs-td :data="data[indextr].id">
                                <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor && data[indextr].customer != undefined">
                                    <span @click="openModal(data[indextr])"><feather type="eye" size="18"/></span>
                                    <span @click="removeRow(data[indextr].AEROTRACK)"><feather type="trash" size="18"/></span>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>

        <modalBasic :show="modalFileState">
            <div class="modal-header" slot="modal-header">Adjuntar Archivo Proveedor</div>
            <div class="modal-body limit-body" slot="modal-body">
                <form class="form">
                    <div class="form-input">
                        <input type="file" @change="uploadFile" ref="file" accept=".xlsx">
                    </div>
                    <div class="updateCosts">
                        <label for="">Actualizar Costos</label>
                        <vs-switch v-model="updateCosts" color="success"/>
                    </div>
                </form>
            </div>
            <div class="modal-footer" slot="modal-footer">
                <vs-button color="danger" type="border" icon="block"  @click="closeModalFile()">Cerrar</vs-button>
                <vs-button :disabled="stateFileUpload || file == ''" id="btnConfirm" color="success" type="border" icon="check" 
                    @click="sendFileToServer" class="vs-con-loading__container"> Enviar</vs-button>
            </div>
        </modalBasic>

        <modalBasic :show="modalState" customClass="facModal">
            <div class="modal-header" slot="modal-header">Detalle de costos</div>
            <div class="modal-body limit-body pt-25 min" slot="modal-body">
                <div class="customer-rate">
                   EL costo por libra para <strong>{{operation?.customer?.firstName +' '+operation?.customer?.lastName }}</strong> es de: <strong>${{ operation?.customer?.rate != null ? 
                        operation.customer?.rate : operation.customer?.customerType?.rate }}</strong>
                </div>
                <form class="form">
                    <div class="group col3">
                        <div :class="['form-input', {'has-error': $v.operation.COST.$error }]" >
                            <vs-input label="Costo del Paquete" v-model.trim="$v.operation.COST.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.operation.COST.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.operation.WEIGHT_LB.$error }]" >
                            <vs-input label="Peso(lb)" v-model.trim="$v.operation.WEIGHT_LB.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.operation.WEIGHT_LB.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                        <div :class="['form-input', {'has-error': $v.operation.LB_COST.$error }]">
                            <vs-input label="Costo por lb" v-model.trim="$v.operation.LB_COST.$model" @keypress="isNumber($event)" />
                            <span class="error-text" v-if="$v.operation.LB_COST.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group">
                        <div class="form-input">
                            <label for="">¿Agregar el 10%?</label>
                            <select-input :options="[{name: 'No', value: '0'}, {name: 'Si', value: '1'}]" v-model="operation.includeTax"></select-input>
                        </div>
                        <div :class="['form-input', {'has-error': $v.operation.TAXES.$error }]" >
                            <vs-input label="Impuestos" v-model.trim="$v.operation.TAXES.$model" @keypress="isNumber($event)"/>
                            <span class="error-text" v-if="$v.operation.TAXES.$error"><feather type="info" />Este campo es requerido</span>
                        </div>
                    </div>
                    <div class="group">
                        <div class="form-input" >
                            <vs-input label="Descuento" v-model.trim="operation.DISCOUNT" @keypress="isNumber($event)"/>
                        </div>
                        <div class="form-input" >
                            <vs-input label="Otros Cargos" v-model.trim="operation.OTHER_CHARGES" @keypress="isNumber($event)"/>
                        </div>
                    </div>
                    <div class="group">
                        <div class="form-input">
                            <label for="">Permiso Adicional?</label>
                            <select-input :options="[{name: 'No', value: '0'}, {name: 'Si', value: '1'}]" v-model="operation.PERMISSIONS"></select-input>
                        </div>
                        <div class="form-input">
                            <label for="">Desea Facturar?</label>
                            <select-input :options="[{name: 'No', value: '0'}, {name: 'Si', value: '1'}]" v-model="operation.INVOICE_READY"></select-input>
                        </div>
                    </div>
                    <p>Total de Flete: <strong> ${{ operation.LB_COST * operation.WEIGHT_LB }}</strong></p>
                    <p>Total de Impuestos: <strong> ${{ getTotalTaxFac() }}</strong></p>
                    <p>Total a Facturar: <strong> ${{ getPreviewTotalFac() }}</strong></p>
                </form>
            </div>
            <div class="modal-footer" slot="modal-footer">
                <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                <vs-button :disabled="$v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                    @click="updatePackage" class="vs-con-loading__container"> Actualizar</vs-button>
            </div>
        </modalBasic>
    
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import OperationModel from '@/models/OperationModel';
import { required } from 'vuelidate/lib/validators'
import modalBasic from '@/components/Modal/Basic.vue'
import OperationService from "@/services/OperationService"
import SelectInput from '@/components/Form/Select-Input.vue'

export default {
  name: 'Operations',
  mixins: [helper],
  components: { modalBasic, SelectInput },
  data () {
    return {
        file: "",
        rowId: 0,
        packages: [],
        allPackages: [],
        onlyBox: false,
        modalState: false,
        updateCosts: false,
        modalFileState: false,
        stateFileUpload: false,
        operation: new OperationModel()
    }
  },
  created(){
    this.Roles = Role
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.getPackages();
    // this.retrievePackages()
  },
  validations: {
    operation: {
        COST: { required },
        WEIGHT_LB: { required },
        TAXES: { required },
        LB_COST: { required },
        // WEIGHT_LB: { required },
        // WEIGHT_LB: { required },
    }
  },
  methods: {
    openModalFile(){
        this.modalFileState  = true;
    },
    closeModalFile(){
        this.file = "";
        this.stateFileUpload = false;
        this.modalFileState  = false;
    },
    openModal(objData){
        let data = {...objData};
        data.COST = parseFloat(data.DECLARED_VALUE);
        data.PERMISSIONS   = data.PERMISSIONS == null ? { name: "No", value: 0 } : { name: "Si", value: 1 };
        data.INVOICE_READY = data.INVOICE_READY == null ? { name: "No", value: 0 } : { name: "Si", value: 1 };
        data.includeTax = { name: "Si", value: 1 };
        data.LB_COST =  data?.customer?.rate != null ? 
                        data.customer?.rate : data.customer?.customerType?.rate;
            
        if(data.WEIGHT_LB == null){
            data.WEIGHT_LB = Math.ceil(data.WEIGHT_KG *  2.20462);
        }
        this.operation  = data;
        this.modalState = true;
    },  
    closeModal(){
        this.modalState = false;
        this.operation  = new OperationModel();
        this.$v.$reset();
    },
    getPackages() {
        OperationService.getPackages({ pageSize: 1000})
        .then(response => {
            this.packages = response.data.items;
            this.allPackages = response.data.items;
            this.$Progress.finish()
        })
        .catch( () => {
          this.$Progress.finish()
        });
    },
    removeRow(index){
        this.rowId = index
        this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: '¿Estas seguro de eliminar la fila?',
        accept: this.confirmDeleteRow
      })
    },
    async confirmDeleteRow(){
        let response = await OperationService.deleteRow({AEROTRACK: this.rowId })
        if((response.status/100) == 2){
            this.$vs.notify({title:'Información',text:'La fila fue eliminada exitosamente!',color:'success',icon:'check'})
            let posIdx = this.packages.findIndex( item => item.AEROTRACK == this.rowId);
            if(posIdx > -1){
                this.packages.splice(posIdx, 1)   
            }
        } else {
            this.$vs.notify({title:'Información',text:'Error eliminado la final',color:'danger',icon:'error_outline'})                
        }
    
    },
    updatePackage(){
        this.operation.PERMISSIONS = this.operation.PERMISSIONS.value == 1 ? 1 : 0;
        this.operation.INVOICE_READY = this.operation.INVOICE_READY.value == 1 ? 1 : 0;
        this.operation.includeTax = this.operation.includeTax.value == 1 ? 1 : 0;
        OperationService.updatePackage(this.operation)
        .then(response => {
            console.log(response);
            this.modalState = false;
            this.operation  = new OperationModel();
            this.$vs.notify({title:'Información!',text:'El paquete fue actualizado exitosamente!',color:'success',icon:'check'});
            window.location.reload();
        })
        .catch( () => {
            this.$vs.notify({title:'Información!',text:'Error actualizando el paquete.',color:'danger',icon:'check'})
        });
    },
    uploadFile(){
        this.file = this.$refs.file.files[0];
    },
    sendFileToServer(){
        const path = this.updateCosts ? '/packages/manifiest/bulkUpdate' : 'packages/manifiest';
        this.stateFileUpload = true;
        let formData = new FormData();
        formData.append('file', this.file);
        OperationService.uploadFileServer(formData, path)
        .then(response => {
            console.log(response);
            this.file = "";
            this.modalFileState = false;
            this.stateFileUpload = false;
            this.$vs.notify({title:'Información!',text:'El archivo fue cargado correctamente!',color:'success',icon:'check'});
            window.location.reload();
        })
        .catch( e => {
            console.log(e);
            this.stateFileUpload = false;
            this.$vs.notify({title:'Información!',text:'Error cargando el archivo.',color:'danger',icon:'check'})
        });
    },
    getTotalTaxFac () {
        console.log('this.operation.TAXES ', this.operation.TAXES );
        let taxes = this.operation.TAXES != null ? parseFloat(this.operation.TAXES) : 0;
        if(this.operation.TAXES !=  null && this.operation.TAXES != ''){
            if(this.operation.includeTax.value == 1){
                taxes = taxes + (parseFloat(this.operation.TAXES * 0.10));
            }
        }
        return taxes;
    },  
    getPreviewTotalFac() {
        // Usa siempre el valor actualizado del costo por libra
        const rate = parseFloat(this.operation.LB_COST) || 9; // Valor por defecto si LB_COST está vacío
        const weight = parseFloat(this.operation.WEIGHT_LB) || 0;
        const discount = parseFloat(this.operation.DISCOUNT) || 0;

        // Total base
        let total = (weight * rate) - discount;

        // Otros cargos
        if (this.operation.OTHER_CHARGES) {
            const otherCharges = parseFloat(this.operation.OTHER_CHARGES) || 0;
            total += otherCharges * 1.13; // Incluye 13% de impuestos
        }

        // Impuestos
        if (this.operation.TAXES) {
            const taxes = parseFloat(this.operation.TAXES) || 0;
            total += this.operation.includeTax.value ? taxes * 1.10 : taxes; // Aplica 10% adicional si incluye impuestos
        }

        return total; // Retorna un valor con 2 decimales
    },
    filterTableOnlyBox(){
        if(this.onlyBox){
            const data = this.allPackages.filter(item => {
                if(item.packStatus != undefined && item.packStatus == 10){
                    return item;
                }
            });
            this.packages = data;
        } else{
            this.packages = this.allPackages;
        }
    }
  }
}
</script>
